import {
	AUTO_SAVE_LOADING,
	AUTO_SAVE_VISIBLE,
	GET_DOCUMENT_CONFIG_DATA,
	GET_DOCUMENT_CONFIG_LOADING,
	SET_LEAD_CANNOT_SWITCH_TO_ORDER_MODAL,
	SET_REVIEW_ORDER_BUYER_IS_LEAD,
	GET_ELLA_ORDER_SETTINGS,
	SET_LINKED_DOCUMENT,
	SET_REVIEW_PAGE_HEADER,
	SET_TASK_SYSTEM_ID,
} from 'src/actions/reduxConstants';
import type { ReviewPageHeader } from 'src/screens/ReviewOrder/utils/reviewPageHeader';

interface Review_order {
	document_config_data: any[];
	loading: boolean;
	auto_save_loading: boolean;
	auto_save_visible: boolean;
	buyer_is_lead: boolean;
	lead_cannot_switch_to_order_modal: boolean;
	ella_order_settings: any[];
	linked_document: any;
	review_page_header: ReviewPageHeader | null;
	task_system_id: string | null;
}

const initialState: Review_order = {
	document_config_data: [],
	loading: false,
	auto_save_loading: false,
	auto_save_visible: false,
	buyer_is_lead: false,
	lead_cannot_switch_to_order_modal: false,
	ella_order_settings: [],
	linked_document: null,
	review_page_header: null,
	task_system_id: null,
};

const review_order_reducer = (state: any = initialState, action: any) => {
	switch (action.type) {
		case GET_DOCUMENT_CONFIG_DATA:
			return {
				...state,
				document_config_data: action.payload,
			};
		case GET_DOCUMENT_CONFIG_LOADING:
			return {
				...state,
				loading: action.payload,
			};
		case AUTO_SAVE_LOADING:
			return {
				...state,
				auto_save_loading: action.payload,
			};

		case AUTO_SAVE_VISIBLE:
			return {
				...state,
				auto_save_visible: action.payload,
			};
		case SET_REVIEW_ORDER_BUYER_IS_LEAD:
			return {
				...state,
				buyer_is_lead: action.payload,
			};
		case SET_LEAD_CANNOT_SWITCH_TO_ORDER_MODAL:
			return {
				...state,
				lead_cannot_switch_to_order_modal: action.payload,
			};
		case GET_ELLA_ORDER_SETTINGS:
			return {
				...state,
				ella_order_settings: action.payload,
			};
		case SET_LINKED_DOCUMENT:
			return {
				...state,
				linked_document: action.payload,
			};
		case SET_REVIEW_PAGE_HEADER:
			return {
				...state,
				review_page_header: action.payload,
			};
		case SET_TASK_SYSTEM_ID:
			return {
				...state,
				task_system_id: action.payload ?? null,
			};

		default:
			return state;
	}
};

export default review_order_reducer;
